import { render, staticRenderFns } from "./OnlineServicesSidebar.vue?vue&type=template&id=f75f8354&scoped=true"
import script from "./OnlineServicesSidebar.vue?vue&type=script&lang=js"
export * from "./OnlineServicesSidebar.vue?vue&type=script&lang=js"
import style0 from "./OnlineServicesSidebar.vue?vue&type=style&index=0&id=f75f8354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75f8354",
  null
  
)

export default component.exports